import { Button, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router';

export function NiNajdeno() {
  return (
    <Stack align="center" mt={80} gap="sm">
      <Title order={2}>Strani ni</Title>
      <Text c="dimmed">Ta stran ne obstaja ali je bila premaknjena.</Text>
      <Button component={Link} to="/racuni" mt="md">
        Na račune
      </Button>
    </Stack>
  );
}
